import React from 'react'

function AwarenessIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.5 13.7513H10.5L14.5833 17.2513V4.41797L10.5 7.91797H3.5V13.7513Z"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.8335 18.4167V13.75H8.16683V18.4167C8.16683 19.061 7.64449 19.5833 7.00016 19.5833C6.35583 19.5833 5.8335 19.061 5.8335 18.4167Z"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5833 13.8333C14.9664 13.8333 15.3456 13.7579 15.6995 13.6113C16.0534 13.4647 16.3749 13.2499 16.6457 12.9791C16.9166 12.7082 17.1314 12.3867 17.278 12.0328C17.4246 11.679 17.5 11.2997 17.5 10.9167C17.5 10.5336 17.4246 10.1544 17.278 9.80051C17.1314 9.44664 16.9166 9.12511 16.6457 8.85427C16.3749 8.58343 16.0534 8.36859 15.6995 8.22202C15.3456 8.07544 14.9664 8 14.5833 8L14.5833 10.9167L14.5833 13.8333Z"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 11H21"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7197 6L18.7804 4.93934"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7197 15L18.7804 16.0607"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AwarenessIcon